import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'

// 路由级角色守卫（组件仍由同目录 index.lazy.tsx 懒加载提供）。
// 与 /prompts 同理：补上直接访问 URL 时的越权拦截。
export const Route = createFileRoute('/_authenticated/admin-announcement/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
})
